import { render } from "./WKHeader.vue?vue&type=template&id=d3b396e0&scoped=true"
import script from "./WKHeader.vue?vue&type=script&lang=js"
export * from "./WKHeader.vue?vue&type=script&lang=js"

import "./WKHeader.vue?vue&type=style&index=0&id=d3b396e0&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\v202008\\wike-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b396e0"]])

export default __exports__